import { LandingComponent } from './landing/landing.component';
import { OffersMicroSitesComponent } from './offers-micro-sites/offers-micro-sites.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'landing/:companyName',
    component: LandingComponent
  },
  {
    path: 'offers-micro/:companyName',
    component: OffersMicroSitesComponent
  },
  {
    path: 'landing',
    redirectTo: 'landing/dreamjobs'
  },
  {
    path: '**',
    redirectTo: 'landing/dreamjobs'
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts